jQuery(document).ready(function($) {

  
  $(window).on("load", function () {
      const selected = $("variant-selects input[type='radio']:checked").val();
      // console.log(selected);
      if (selected === "Ready to wear saree") {
          $(".tpo_option-set-wrapper").show();
          setTimeout(() => {
              $(".tpo_add-to-cart").attr("disabled", true);
          }, 800);
      }
      else {
          $(".tpo_option-set-wrapper").hide();
          $(".tpo_add-to-cart").removeAttr("disabled");
      }
      $("button.sr-headless-checkout span.sr-checkout-visible2").text("Buy now");
  });

  jQuery(document).ready(function($) {
  
      $(document).on('change', "variant-selects input[type='radio']", function () {
          const selectedValue = $("variant-selects input[type='radio']:checked").val();
          // console.log(selectedValue);
          if (selectedValue === "Ready to wear saree") {
              $(".tpo_option-set-wrapper").slideDown().find("input").attr("required", true);
              setTimeout(() => {
                  $(".tpo_add-to-cart").attr("disabled", true);
              }, 800);
          }
          else {
              $(".tpo_option-set-wrapper").slideUp().find("input").removeAttr("required");
              setTimeout(() => {
                  $(".tpo_add-to-cart").removeAttr("disabled");
              }, 800);
          }
      });

      function checkBothInputs() {
          const waist = $('input[name="properties[Waist]"]').val().trim();
          const height = $('input[name="properties[Height]"]').val().trim();
          
          if (waist !== "" && height !== "") {
              setTimeout(() => {
                  $(".tpo_add-to-cart").removeAttr("disabled");
              }, 800);
      
          } else {
              setTimeout(() => {
                  $(".tpo_add-to-cart").attr("disabled", true);
              }, 800);
          }
      }
      
      $(document).on('blur input', 'input[name="properties[Waist]"], input[name="properties[Height]"]', checkBothInputs);

  
  });

});
